<template>
  <div class="forms">
    <div class="h22 filter">
      <div> <a-radio-group v-model="kType" @change="resh">
          <a-radio-button :value="1">即将到期({{ top.expireCount }})</a-radio-button>
          <a-radio-button :value="0">已到期({{ top.expiredCount }})</a-radio-button>
        </a-radio-group>
        <label style="padding-left: 20px;">原告：</label>
        <a-select show-search v-model="accuser_ids" placeholder="请选择" mode="multiple" :maxTagCount='1'
          :maxTagTextLength='16' allowClear class="select" option-filter-prop="children" :not-found-content="null"
          style="width:240px;">
          <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id" :title="item.title">
            {{ item.title }}
          </a-select-option>
        </a-select>
      </div>
      <a-button icon="search" @click="$refs.table.resh()">查询</a-button>
    </div>
    <div class="table">
      <Table :formKey='putData.formKey' :getUrl='putData.url[kType]' :query='q' ID='debtor_id' ref='table'
        v-if='$common.AUTH("welcome:keep")'>
        <template v-slot:pick='v'>
          <span v-if='$common.AUTH("debtor:info")'>
            <router-link :to='{ "name": "lydetails", params: { "id": v.id } }' class="curpoter" target="_blank"
              style='color: #1d8bfe;'> 查看 </router-link>
          </span>
          <span v-else>查看</span>
        </template>
      </Table>
      <div class="nqx smnq" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
import Table from './table.vue'
import { getAccuserAll } from '@/server/api'
export default {
  name: 'Collect',
  props: {
    putData: Object
  },
  data() {
    return {
      kType: 1,
      accuserList: [],
      accuser_ids: []
    }
  },
  computed: {
    top() {
      return this.$store.state.Home.Top
    },
    q() {
      return { accusers: this.accuser_ids.toString() }
    }
  },
  created() {
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
  },
  methods: {

    resh() {
      setTimeout(e => {
        this.$refs.table.resh()
      }, 200)
    }
  },
  components: { Table }
}
</script>
<style lang="less" scoped>
.filter {
  display: flex;
  justify-content: space-between;
}
</style>
<style>
.custom-tip .ant-tooltip-inner {
  background-color: #ffffff !important;
  color: #000 !important;
}

.custom-tip [class*='ant-tooltip-arrow']::before {
  background: #ffffff !important;
  border-color: #ffffff !important;
}
</style>